import styled, { keyframes } from 'styled-components';

import { ControlledMenu } from '@szhsin/react-menu';
import {
  menuSelector,
  menuDividerSelector,
} from '@szhsin/react-menu/style-utils';

export const Container = styled.div``;

export const Label = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  cursor: pointer;
`;

export const DateContainer = styled.div`
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #d8dae5;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 8px;
  width: 124px;
`;

interface IDateText {
  hasDate: boolean;
}

export const DateText = styled.div<IDateText>`
  font-weight: ${({ hasDate }) => (hasDate ? '500' : '400')};
  font-size: 12px;
  color: ${({ hasDate }) => (hasDate ? '#474d66' : '#696F8C')};
  padding-top: 2px;
`;

export const DateIcon = styled.div`
  height: 24px;
`;

interface IDateButton {
  hasDate: boolean;
}

export const DateButton = styled.div<IDateButton>`
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #d8dae5;
  background: ${({ hasDate }) => (hasDate ? '#E6EDFF' : '#edeff4')};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  margin-left: -1px;
`;

const menuShow = keyframes`
  from {
    opacity: 0;
  }
  `;
const menuHide = keyframes`
  to {
    opacity: 0;
  }
  `;

export const Dialog = styled(ControlledMenu)`
  ${menuSelector.name} {
    font-size: 0.925rem;
    user-select: none;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
    border-radius: 8px;
    transition: unset;
  }

  ${menuSelector.stateOpen} {
    animation: ${menuShow} 0.2s linear;
  }

  // NOTE: animation-fill-mode: forwards is required to
  // prevent flickering with React 18 createRoot()
  ${menuSelector.stateClosing} {
    animation: ${menuHide} 0.2s ease-out forwards;
  }

  ${menuDividerSelector.name} {
    margin: 0.5rem 0.625rem;
  }

  .szh-menu {
    min-width: unset !important;
    width: 318px !important;
    padding: 4px !important;
    background: #ffffff;
    box-shadow: 0px 12px 28px rgba(33, 39, 73, 0.2);
    border-radius: 4px;
  }

  .MuiPickersDatePickerRoot-toolbar {
    display: none;
  }
`;
